import { FC } from 'react';
import { sortBy } from 'lodash';
import { Redirect, useParams } from 'react-router-dom';
import { Content } from '@/components/layout/Content';
import { LoadingPage } from '@/components/LoadingPage';
import { NotFound } from '@/components/NotFound';
import { useQuery } from '@/hooks/graphql/useQuery';
import { EmployeeInfo } from './parts/EmployeeInfo';
import { PersonalResults } from './parts/PersonalResults';
import {
  PERSONAL_RESULTS,
  PersonalResultsQueryResult,
  PersonalResultsQueryVariables,
  REGULAR_HEALTH_CHECKUP_RESULT,
  RegularHealthCheckupResultQueryResult,
  RegularHealthCheckupResultQueryVariables
} from './query';
import { PersonalResult } from '@/pages/regular_health_checkup/personal_results/show/parts/PersonalResult';

interface SearchParams {
  personalId: string;
  resultId?: string;
}

export const ShowPersonalResults: FC = () => {
  const { personalId, resultId } = useParams<SearchParams>();
  const summaryQuery = useQuery<PersonalResultsQueryResult, PersonalResultsQueryVariables>(PERSONAL_RESULTS, {
    variables: { personalId },
    fetchPolicy: 'network-only'
  });

  const employee = summaryQuery.data?.client?.employee;
  const regularHealthCheckupResults = sortBy(employee?.regularHealthCheckupResults, item => item.dateOn);

  const currentResultId = resultId || regularHealthCheckupResults.at(-1)?.id;
  const resultQuery = useQuery<RegularHealthCheckupResultQueryResult, RegularHealthCheckupResultQueryVariables>(
    REGULAR_HEALTH_CHECKUP_RESULT,
    {
      variables: { personalId, resultId: String(currentResultId) },
      skip: !employee || !currentResultId,
      fetchPolicy: 'network-only'
    }
  );
  const regularHealthCheckupResult = resultQuery.data?.client.regularHealthCheckupResult;

  if (!summaryQuery.loading && !employee) {
    return <NotFound />;
  }

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">個人結果詳細</h1>
      </div>
      <Content size="xl-4">
        {employee ? (
          <>
            <EmployeeInfo employee={employee} />
            <PersonalResults
              employee={employee}
              results={regularHealthCheckupResults}
              currentResultId={currentResultId}
            />
            {currentResultId &&
              (resultQuery.loading ? (
                <LoadingPage />
              ) : regularHealthCheckupResult ? (
                <PersonalResult employee={employee} result={regularHealthCheckupResult} />
              ) : (
                <Redirect to={`/regular_health_checkup/personal_results/${personalId}`} />
              ))}
          </>
        ) : (
          <LoadingPage />
        )}
      </Content>
    </div>
  );
};
